import Vue from 'vue';
import Vuex from 'vuex';
import act from '../actions/global';
import mut from '../mutations/global';

import config from '../../config/config';

import * as signalR from '@aspnet/signalr';


Vue.use(Vuex);

const store =  {
    state:{
        connection: "",
        heats: null,
        selectedHeat: "",
        selectedEntrantId: "",
        cEntryId: "",
        nEntryId: null,
        selectedResultId: '',
        cResultId: '',
        nResultId: null,
        cHeightGuid: null,
        heatId: null,
        logedIn : false,
        heartBeat: null,
        connectionState: 0,
        lastTAFBeat: 0,
        wkbHelp: false,
        editEntryId: null,
        nextDrop: 0,
        isConnecting: false,
        isHeatsLoading: false,

    },
    mutations: {
        [mut.SETHEARTBEAT]: (state, interval) => {
            state.heartBeat = interval;
        },
        [mut.SETLOGIN]: (state, { pw, id }) => {
            localStorage.setItem('pw', JSON.stringify(pw));
            localStorage.setItem('cId', JSON.stringify(id));
            state.logedIn = true;
        },
        [mut.LOGOUT]: (state) => {
            localStorage.clear();
            state.heats = null;
            state.selectedHeat = "";
            state.selectedEntrantId = "";
            state.selectedResultId = '';
            state.cEntryId = '';
            state.cResultId = '';
            state.cHeightGuid = null;
            state.logedIn = false;
        },
        [mut.UNSETHEATDATA]: (state) => {
            localStorage.setItem('sHeatGuid', null);
            state.selectedHeat = "";
            state.selectedEntrantId = "";
            state.selectedResultId = '';
            state.cEntryId = '';
            state.cResultId = '';
            state.cHeightGuid = null;
            state.heatId = null;
        },
        [mut.SETCONNECTION]: (state, connection) => {
            state.connection = connection;
        },
        [mut.SETCONNECTIONSTATE]: (state, cState) => {
            state.connectionState = cState;
        },
        [mut.SETWKBHELP]: (state, wkb) => {
            state.wkbHelp = wkb;
        },
        [mut.SETHEATS]: (state, heats) => {
            state.isHeatsLoading = false;
            localStorage.setItem('heats', JSON.stringify(heats));
            state.heats = heats;
        },
        [mut.SETHEIGHTS]: (state, payload) => {
            state.selectedHeat.heights = payload.heights;
            state.selectedHeat.entries = payload.entries;
        },
        [mut.SETSELECTEDHEAT]: (state, payload) => {
            state.heatId = payload.id;
            if (payload.heat) {
                if (payload.heat.heights.length != 0) {
                    payload.heat.heights = payload.heat.heights.sort((a, b) => {
                        if (a.order < b.order) return -1
                        if (a.order > b.order) return 1
                        return 0
                    })
                }
                if (payload.heat.entries.length != 0) {
                    payload.heat.entries = payload.heat.entries.sort((a, b) => {
                        if (a.startPos < b.startPos) return -1
                        if (a.startPos > b.startPos) return 1
                        return 0
                    })
                }
                state.selectedEntrantId = payload.heat.currentEntry == null ? 0 : payload.heat.entries.findIndex(x => x.id == payload.heat.currentEntry);
                state.selectedResultId = payload.heat.currentTry || 0;

                state.cEntryId = state.selectedEntrantId;
                state.cResultId = state.selectedResultId;
                if (payload.heat.heights.length !== 0) {                    
                    if(state.cResultId < payload.heat.heights.length){
                        state.cHeightGuid = payload.heat.heights[state.cResultId].id;
                    }
                    else {
                        state.cHeightGuid = payload.heat.heights[0].id;
                        state.cResultId = 0;
                    }
                }
                state.selectedHeat = payload.heat;
                localStorage.setItem('sHeatGuid', JSON.stringify(payload.id));
                localStorage.setItem(state.selectedHeat.id, JSON.stringify({heat: state.selectedHeat, dirty: false}));
            }
            else{
                state.selectedHeat = null;
            }
        },
        [mut.SETHEATSTATE]: (state, st) => {
            state.selectedHeat.state = st;
            localStorage.setItem(state.selectedHeat.id, JSON.stringify({ heat: state.selectedHeat, dirty: true }));
        },
        [mut.SETDROPEDENTRANTS]: (state, entrants) => {
            state.selectedHeat.entries = entrants;
            localStorage.setItem(state.selectedHeat.id, JSON.stringify( { heat: state.selectedHeat, dirty: true }));
        }, 
        [mut.RANKUPDATE]: (state, rank) => {
            const e = state.selectedHeat.entries.find(x => x.id == rank.id);
            if(e) {
                e.rank = rank.rank;
                e.isEnabled = rank.isEnabled;
                e.bestResultId = rank.bestResultId;
                rank.resultUpdates.forEach(ru => {
                    const res = e.results.find(r => r.id === ru.id);
                    if(res)
                        res.isEnabled = ru.isEnabled;
                })
            }
            localStorage.setItem(state.selectedHeat.id, JSON.stringify({ heat: state.selectedHeat, dirty: true }));
            state.selectedHeat.entries.push(null);
            state.selectedHeat.entries.pop();
        },
        [mut.SETRESULTIDS]: (state, payload) => {
            state.selectedEntrantId = payload.eId!==null ? payload.eId : state.selectedEntrantId;
            state.selectedResultId = payload.rId !== null ? payload.rId : state.selectedResultId;
            if (payload.src == 'cc') {
                state.cEntryId = payload.eId !== null ? payload.eId : state.cEntryId;
                state.cResultId = payload.rId !== null ? payload.rId : state.cResultId;
                state.cHeightGuid = state.selectedHeat != "" && state.selectedHeat.entries[state.cEntryId].results.length != 0 ?  state.selectedHeat.entries[state.cEntryId].results[state.cResultId].heightId : null;
                state.nEntryId = payload.nEId;
                state.nResultId = payload.nRId;
                state.selectedHeat.currentEntry = state.selectedHeat.entries[state.cEntryId].id;
                state.selectedHeat.currentTry = state.cResultId;
                localStorage.setItem(state.selectedHeat.id, JSON.stringify({ heat: state.selectedHeat, dirty: true }));
            }
            state.selectedHeat.entries.push(null);
            state.selectedHeat.entries.pop();
        },
        [mut.REGISTERHUB]: (state, payload) => {  
            if (state.connectionState)      
                state.connection.on(payload.name, payload.method);
        },
        [mut.UNREGISTERHUB]: (state, payload) => {    
            if (state.connectionState)  
                state.connection.off(payload.name, payload.method);
        },
        [mut.UPDATEEVENTSTATE]: (state, eventState) => {
            var temp = state.selectedHeat;
            temp.state = eventState;
            state.selectedHeat = temp;
            localStorage.setItem(state.selectedHeat.id, JSON.stringify({ heat: state.selectedHeat, dirty: true }));
            
        },
        [mut.SETEDITENTRYID]: (state, id) => {
            state.editEntryId = id;
        },
        [mut.UPDATEENTRY]: (state, entry) => {
            state.selectedHeat.entries[state.editEntryId] = entry;
            localStorage.setItem(state.selectedHeat.id, JSON.stringify({ heat: state.selectedHeat, dirty: true }));
        },
    },
    actions: {
        [act.CONNECT]: ({ commit, dispatch, state, rootGetters }) => {
            try {
                state.isConnecting = true;
                var connection = new signalR.HubConnectionBuilder()
                    .withUrl(config.HUBURL)
                    .build();  
                
                connection.start()
                    .then(function () {
                        state.isConnecting = false;
                        commit(mut.SETCONNECTION, connection);
                        commit(mut.SETCONNECTIONSTATE, 1);
                        state.connection.on('Returnbeat', (data) => {
                            if (data.isAlive) {
                                commit(mut.SETCONNECTIONSTATE, 1);
                            }
                            else {
                                commit(mut.SETCONNECTIONSTATE, 2);
                            }
                        });
                    })
                    .catch(function (err) {
                        state.isConnecting = false;
                        commit(mut.SETCONNECTION, "");
                        commit(mut.SETCONNECTIONSTATE, 0);
                    })
                    .finally(function () {
                        state.isConnecting = false;
                        if (!state.heartBeat) {
                            commit(mut.SETHEARTBEAT, setInterval(() => {
                                if (state.connection.connectionState) {
                                    if (rootGetters.CId && rootGetters.CId != "") {
                                        dispatch(act.SENDHEARTBEAT);
                                    }
                                }
                                else {
                                    commit(mut.SETCONNECTION, "");
                                    commit(mut.SETCONNECTIONSTATE, 0);
                                    dispatch(act.CONNECT);
                                }
                            }, 5000));
                        }
                    });
                
            }
            catch(error){
                console.error(error);
            }
        },
        [act.LOGIN]: ({ state, rootGetters }, data) => {
            try {
                state.connection.invoke("Login", rootGetters.SelectedCompetition.id, data.pw).catch(function (err) {
                    return console.error(err.toString());
                }); 
            }
            catch(error) {
                console.error(error);
            }
        },
        [act.GETHEATS]: ({ state, rootGetters }) => {
            state.isHeatsLoading = true;
            try {
                state.connection.invoke('RequestHeatList', rootGetters.CId).catch(function (err) {
                    state.isHeatsLoading = false;
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.SENDWKBHELP]: ({ state }, message) => {
            try {
                state.connection.invoke('SendMessage', state.heatId, message).catch(function (err) {
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.GETHEATDETAILS]: ({ state }) => {
            try {
                state.connection.invoke('RequestHeatDetails', state.heatId).catch(function(err){
                    return console.log(err.toString());
                });
            }
            catch(error){
                console.log(error);
            }
        },
        [act.SENDHEATGROUP]: ({ state }, heat) => {
            if(state.connectionState !== 0) {
                heat = heat || state.selectedHeat;
                try {
                    state.connection.invoke('SendHeatgroup', heat).catch(function (err) {
                        return console.log(err.toString());
                    });
                }
                catch (error) {
                    console.log(error);
                }
            }
        },
        [act.SETHEATGROUPSTATUS]: ({ state, commit },  p) => {
            if(state.connectionState !== 0) {
                commit(mut.SETHEATSTATE, p.state);
                state.connection.invoke("SetHeatgroupStatus", state.heatId, p.state).catch(function (err) {
                    return console.error(err.toString());
                });
            }
        },
        [act.SENDRESULT]: ({ state }, payload) => {
            if(state.connectionState !== 0){
                try {
                    state.connection.invoke('SendResult', state.heatId, payload.eId, payload.result).catch(function (err) {
                        return console.log(err.toString());
                    });
                }
                catch (error) {
                    console.log(error);
                }
            }
            localStorage.setItem(state.selectedHeat.id, JSON.stringify({ heat: state.selectedHeat, dirty: true }));
        },
        [act.SENDHEARTBEAT]: ({ state, commit, rootGetters }) => {
            try {
                state.connection.invoke('SendHeartbeat', rootGetters.CId).catch(function (err) {
                    commit(mut.SETCONNECTIONSTATE, 0);
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.SENDCURRENTCURSOR]: ({ state }, p) => {
            try {
                state.connection.invoke('SendCurrentCursor', state.heatId, p.eId, p.cResultId, p.cHeightId).catch(function (err) {
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.AUTODROP]: ({ state }, p) => {
            try {
                state.connection.invoke('SendDropAction', p).catch(function (err) {
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.REQUESTPOOLMERGEAVAILABLE]: ({ state, dispatch }, t) => {
            try {
                const request = (data, st) => {
                    state.connection.off('SendPoolMergeAvailableInformation');
                    switch(st) {
                        case 0:
                            if (confirm(t.$i18n.t('text.poolMergeMessage.request'))) {
                                dispatch(act.SENDPOOLMERGE);
                            }
                            break;
                        case 1:
                            alert(t.$i18n.t('text.errroUnknowen'));
                            break;
                        case 2:
                            alert(t.$i18n.t('text.errroUnknowen'));
                            break;
                        case 3:
                            alert(t.$i18n.t('text.poolMergeMessage.errorToLessGroups'));
                            break;
                        case 4:
                            alert(t.$i18n.t('text.poolMergeMessage.errorAlreadyMerged'));
                            break;
                        case 5:
                            alert(t.$i18n.t('text.poolMergeMessage.errorResultsMissing'));
                            break;
                        case 6:
                            alert(t.$i18n.t('text.poolMergeMessage.errorResultsMissing'));
                            break;
                    }
                };
                state.connection.on('SendPoolMergeAvailableInformation', request);

                state.connection.invoke('RequestPoolMergeAvailableInformation', state.selectedHeat.id).catch(function (err) {
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.SENDPOOLMERGE]: ({ state }) => {
            try {
                state.connection.invoke('RequestPoolMerge', state.selectedHeat.id).catch(function (err) {
                    return console.log(err.toString());
                });
            }
            catch (error) {
                console.log(error);
            }
        },
        [act.SAVEENTRYCHANGES]: ({ state, commit, dispatch }, entry) => {
            commit(mut.UPDATEENTRY, entry);
            dispatch(act.SENDHEATGROUP);
        },
    },
    getters: {
        Events: state => state.heats,
        SelectedHeat: state => state.selectedHeat,
        Entries: state => state.selectedHeat ? state.selectedHeat.entries : null,
        HeatState: state => state.selectedHeat ? state.selectedHeat.state : null,
        HeatGuid: state => state.heatId,
        SelectedEntrantId: state => state.selectedEntrantId,
        SelectedResultId: state => state.selectedResultId,
        CEntryId: state => state.cEntryId,
        NEntryId: state => state.nEntryId,
        CResultId: state => state.cResultId,
        NResultId: state => state.nResultId,
        CHeightGuid: state => state.cHeightGuid,
        Connection: state => state.connection,
        IsAuthenticated: state => state.logedIn,
        ConnectionState: state => state.connectionState,
        IsResultCurrent: state => state.cEntryId == state.selectedEntrantId && state.cResultId == state.selectedResultId,
        WKBHelp: state => state.wkbHelp,
        EditEntry: state => state.selectedHeat.entries[state.editEntryId],
        IsConnecting: state => state.isConnecting,
        IsHeatsLoading: state => state.isHeatsLoading,
    }

};

export default store;